import React from 'react';

import { Flex, Tag, Typography } from 'antd';

import { CourtInfo, courtsSurfaceTagColors, courtsTypeTagColors, courtSurfaceTypesTittle, courtTypesTittle } from 'features/courts';

interface Props {
  selectedCourt: CourtInfo;
}

function ColumnTittle({ selectedCourt }: Props) {
  return (
    <>
      <Typography.Text style={{ fontSize: '12px' }}>{selectedCourt.name}</Typography.Text>
      <Flex justify='space-between' style={{ marginTop: '8px' }}>
        <Tag style={{ fontSize: '9px', padding: '2px 3px', lineHeight: '12px' }} color={courtsSurfaceTagColors[selectedCourt.surfaceType]}>
          {courtSurfaceTypesTittle[selectedCourt.surfaceType].toUpperCase()}
        </Tag>
        <Tag style={{ fontSize: '9px', padding: '2px 3px', lineHeight: '12px' }} color={courtsTypeTagColors[selectedCourt.type]}>
          {courtTypesTittle[selectedCourt.type].toUpperCase()}
        </Tag>
      </Flex>
    </>
  );
}

export default ColumnTittle;
